import { render, staticRenderFns } from "./userImport.vue?vue&type=template&id=47ea68fe&"
import script from "./userImport.vue?vue&type=script&lang=js&"
export * from "./userImport.vue?vue&type=script&lang=js&"
import style0 from "./userImport.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports